// The words come from the mobile app's ARB files (ADR 0008): one set of strings for both apps.
// ARB is JSON with ICU messages; keys starting with "@" are metadata for translators.
import enArb from '../../../app/lib/l10n/app_en.arb?raw';
import ltArb from '../../../app/lib/l10n/app_lt.arb?raw';

export type Locale = 'lt' | 'en';
export const locales: readonly Locale[] = ['lt', 'en'];

function messagesOf(arb: string): Record<string, string> {
  const json = JSON.parse(arb) as Record<string, unknown>;
  return Object.fromEntries(
    Object.entries(json).filter((e): e is [string, string] => !e[0].startsWith('@') && typeof e[1] === 'string'),
  );
}

export const messages: Record<Locale, Record<string, string>> = { lt: messagesOf(ltArb), en: messagesOf(enArb) };

/** The browser's language when the app has it; Lithuanian otherwise, as in the mobile app. */
export function systemLocale(languages: readonly string[] = navigator.languages): Locale {
  for (const l of languages) {
    const code = l.slice(0, 2).toLowerCase();
    if ((locales as readonly string[]).includes(code)) return code as Locale;
  }
  return 'lt';
}
